'use client';

import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import CCPALink from '@/components/CCPALink';
import ConsentPreferenceCenter from '@/components/ConsentPreferenceCenter';
import { detectRegion, ConsentRegion } from '@/lib/consent';

export default function Footer() {
  const [showCookiePrefs, setShowCookiePrefs] = useState(false);
  const [consentRegion, setConsentRegion] = useState<ConsentRegion>('GDPR');
  const [year, setYear] = useState<number | null>(null);

  useEffect(() => {
    setYear(new Date()?.getFullYear());
    detectRegion()?.then((r) => setConsentRegion(r));
  }, []);

  return (
    <>
      <footer className="bg-white border-t border-gray-100 py-8">
        <div className="max-w-6xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-2">
            <Image
              src="/assets/images/logo_v2.2_blue-1784210789861.png"
              alt="CoLoco logo"
              width={24}
              height={24}
              className="rounded-md flex-shrink-0"
            />
            <span className="text-sm font-bold text-gray-700">CoLoco</span>
          </div>
          <p className="text-xs text-gray-400">© {year ?? ''} CoLoco. Collaborative photo mapping</p>
          <div className="flex flex-wrap items-center gap-3">
            <Link href="/privacy" className="text-xs text-gray-400 hover:text-gray-600 transition-colors">Privacy Policy</Link>
            <Link href="/cookies" className="text-xs text-gray-400 hover:text-gray-600 transition-colors">Cookie Policy</Link>
            <button
              onClick={() => setShowCookiePrefs(true)}
              className="text-xs text-gray-400 hover:text-gray-600 transition-colors"
            >
              Cookie Preferences
            </button>
            {consentRegion === 'CCPA' && <CCPALink />}
          </div>
        </div>
      </footer>
      {showCookiePrefs && (
        <ConsentPreferenceCenter
          region={consentRegion}
          onSave={() => setShowCookiePrefs(false)}
          onClose={() => setShowCookiePrefs(false)}
        />
      )}
    </>
  );
}
